import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';
const baseURL = isProduction
  ? 'https://api.zeku-crew-kit.com/api/v1' // 本番環境のURL
  : 'http://localhost:3001/api/v1';

const client = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default client;
